import { api } from '../../../services/api'

/**
 * Callback for banking KYC.
 *
 * @endpoint GET /api/verify/banking_kyc/callback
 * @scope shared
 * @see https://flecto.dev/api-4724198
 */
export async function verifyUserBankingKycCallback(
  options?: VerifyUserBankingKycCallbackOptions
): Promise<void> {
  await api.get('/api/verify/banking_kyc/callback', {
    params: options,
  })
}

export type VerifyUserBankingKycCallbackOptions = {
  ResourceId: string
  EventType: string
  Date: string
}
